module.exports = require('./helpers/bundle-url').getBundleURL('ksUvU') + "local_icon.67c09a45.png" + "?" + Date.now();